(function ($) {
        if ($('.page-template-template-prekes-ukio').length || $('.page-template-template-prekes-sodo').length) {
            //
            // Polyfill for object.assign, needed for lozad plugin to work on IE11
            //
            // window.ObjectAssign.polyfill();

            var url = new URL(window.location);
            var urlParams = (new URL(document.location)).searchParams;

            //Delay function for User input
            function delay(callback, ms) {
                var timer = 0;
                return function () {
                    var context = this, args = arguments;
                    clearTimeout(timer);
                    timer = setTimeout(function () {
                        callback.apply(context, args);
                    }, ms || 0);
                };
            }

            //Category select and URL change
            $('.filter-dropdown .dropdown-select').on('click', function () {
                var params = [];
                var inputs = $('.dropdown-select');
                var category = $(this).attr('data-category');

                if ($(this).hasClass('selected')) {
                    $('.category-selection[data-category="' + category + '"]').removeClass('hidden');
                    $(inputs).each(function (index, el) {
                        if ($(el).hasClass('selected')) {
                            params.push($(el).attr('data-category'));
                        }
                    });
                    updateUrlParams('category', params.join(','));
                } else {
                    $('.category-selection[data-category="' + category + '"]').addClass('hidden');
                    updateUrlParams('category');
                    $(inputs).each(function (index, el) {
                        if ($(el).hasClass('selected')) {
                            params.push($(el).attr('data-category'));
                        }
                    });
                    updateUrlParams('category', params.join(','));
                }
                $('.products-columns').attr('data-page', '1');
                updateUrlParams('pages');

                getProducts();
            });

            //Product search with input
            $('.search-input').on('change, keyup', delay(function (e) {
                updateUrlParams('search', $(this).val());
                $('.category-selection[data-type="search"]').removeClass('hidden');
                $('.category-selection[data-type="search"]').text($(this).val());
                $('.products-columns').attr('data-page', '1');
                updateUrlParams('pages');
                getProducts();
                if ($(this).val().length === 0) {
                    $('.category-selection[data-type="search"]').addClass('hidden');
                }
            }, 400));


            //Remove Search query
            $('.category-selection[data-type="search"]').on('click', function () {
                $(this).addClass('hidden');
                $('.search-input').val('');
                updateUrlParams($(this).attr('data-type'));
                $('.products-columns').attr('data-page', '1');
                updateUrlParams('pages');
                getProducts();
            });

            //Remove Category query
            $('.category-selection[data-type="category"]').on('click', function () {
                var params = [];
                var inputs = $('.dropdown-select');
                var category = $(this).attr('data-category');
                $(this).addClass('hidden');
                $('.dropdown-select[data-category="' + category + '"]').removeClass('selected');

                updateUrlParams('category');
                $(inputs).each(function (index, el) {
                    if ($(el).hasClass('selected')) {
                        params.push($(el).attr('data-category'));
                    }
                });
                updateUrlParams('category', params.join(','));
                $('.products-columns').attr('data-page', '1');
                updateUrlParams('pages');
                getProducts();
            });


            //Calculate pagination numbers and add styling
            function checkPagination(max = 0) {
                var currentPage = $('.products-columns').attr('data-page');
                $('.pagination').removeClass('active');
                $('.products-columns').removeClass('pagination-active');
                if (max > 1) {
                    $('.pagination').addClass('active');
                    $('.products-columns').addClass('pagination-active');
                }
                if ($('.products-columns').attr('data-page') <= 1) {
                    $('.pagination .pag-prev').addClass('disabled');
                } else {
                    $('.pagination .pag-prev').removeClass('disabled');
                }
                if ($('.products-columns').attr('data-page') >= max) {
                    $('.pagination .pag-next').addClass('disabled');
                } else {
                    $('.pagination .pag-next').removeClass('disabled');
                }

                $('.pagination-numbers').empty();

                if (parseInt(currentPage) - 1 > 2) {
                    $('.pagination-numbers').append('<span class="page-number" data-page="' + 1 + '">' + 1 + '</span>');
                    $('.pagination-numbers').append('<span class="page-number dots">...</span>');
                } else if (parseInt(currentPage) - 1 > 1) {
                    $('.pagination-numbers').append('<span class="page-number" data-page="' + 1 + '">' + 1 + '</span>');
                }

                for (var prevPage = parseInt(currentPage) - 2; prevPage < parseInt(currentPage); prevPage++) {
                    if (prevPage > 0 && prevPage > parseInt(currentPage) - 2) {
                        $('.pagination-numbers').append('<span class="page-number" data-page="' + prevPage + '">' + prevPage + '</span>');
                    }
                }

                $('.pagination-numbers').append('<span class="page-number current" data-page="' + currentPage + '">' + currentPage + '</span>');

                for (var nextPage = parseInt(currentPage) + 1; nextPage < parseInt(currentPage) + 2; nextPage++) {
                    if (nextPage <= max) {
                        $('.pagination-numbers').append('<span class="page-number" data-page="' + nextPage + '">' + nextPage + '</span>');
                    }
                }

                if (max > 2 && parseInt(currentPage) + 1 < max - 1) {
                    $('.pagination-numbers').append('<span class="page-number dots">...</span>');
                    $('.pagination-numbers').append('<span class="page-number" data-page="' + max + '">' + max + '</span>');
                } else if (max > 2 && parseInt(currentPage) + 1 < max) {
                    $('.pagination-numbers').append('<span class="page-number" data-page="' + max + '">' + max + '</span>');
                }
            }

            //Pagination numbers even listeners
            $(document).on("click", ".page-number", function () {
                $(this).addClass('current');
                $(this).siblings().removeClass('current');

                var value = $(this).attr('data-page');
                updateUrlParams('pages', value);

                $('.products-columns').attr('data-page', $(this).attr('data-page'));

                getProducts();
            });

            $('.pag-next').on('click', function () {
                var current = $('.products-columns').attr('data-page');

                $('.products-columns').attr('data-page', parseInt(current) + 1);

                updateUrlParams('pages', $('.products-columns').attr('data-page'));

                getProducts();
            });

            $('.pag-prev').on('click', function () {
                var current = $('.products-columns').attr('data-page');

                $('.products-columns').attr('data-page', parseInt(current) - 1);

                updateUrlParams('pages', $('.products-columns').attr('data-page'));

                getProducts();
            });

            $('.sort-switcher .current').on('click', function () {
                $(this).parent().toggleClass('active');
            });

            $('.sort-item').on('click', function () {
                $('.sort-switcher').removeClass('active');
                $('.sort-switcher .current').find('.text').text($(this).text());

                updateUrlParams('sort', $(this).attr('data-sort'));
                getProducts();
            });

            $('body').on('click', function (e) {
                if ($(e.target).closest('.sort-switcher').length === 0) {
                    $('.sort-switcher').removeClass('active');
                }
            });

            //Get all products by queries
            function getProducts() {
                var urlParams = new URLSearchParams(location.search);
                $('html, body').animate({scrollTop: $('#products').offset().top}, 1000);
                var data = {
                    'action': 'load_products',
                    'pages': $('.products-columns').attr('data-page'),
                    'category': urlParams.get('category'),
                    'post_type': $('.products-columns').attr('data-post-type'),
                    'search': urlParams.get('search'),
                    'sort': urlParams.get('sort'),
                };

                $('.products-columns').addClass('loading');
                $('.filters').addClass('loading');
                $('.product-grid').empty();
                checkPagination();

                setTimeout(function () {
                    $.get(postmpwp.ajax_url, data, function (response) {
                        if (response.success) {
                            $('.product-grid').empty();
                            $('.products-columns').removeClass('loading');
                            $('.filters').removeClass('loading');
                            $('.product-grid').append(response.data.products);
                            $('.products-columns').attr('data-max-page', response.data.max_num);
                            checkPagination(response.data.max_num);
                            $('.no-results').removeClass('active');
                        } else {
                            $('.products-columns').removeClass('loading');
                            $('.filters').removeClass('loading');
                            $('.no-results').addClass('active');
                        }
                    });
                }, 600);
            }

            function updateUrlParams(param, value) {
                if (value) {
                    urlParams.set(param, value);

                } else {
                    urlParams.delete(param);
                }

                url.search = urlParams.toString();

                history.replaceState({}, null, url.toString());
            }

            $(window).on('load', function () {
                getProducts();
            })
        }
    }
)(jQuery);